export enum PackageV1UpdateType {
  REFRESH_AUTOMATIC_CONTRACT = 'REFRESH_AUTOMATIC_CONTRACT',
  SYNC_PRODUCT_CONTRACT = 'SYNC_PRODUCT_CONTRACT',
}

export interface IPackageV1UpdateHistoryEntry {
  packageV1Id?: string;
  packageV1Reference?: string;
  contractId?: number;
  contractRef?: string;
  productRef?: string;
  type?: PackageV1UpdateType;
  performedAt?: string;
  userLogin?: string;
}

export class PackageV1UpdateHistoryEntry
  implements IPackageV1UpdateHistoryEntry
{
  constructor(
    public packageV1Id?: string,
    public packageV1Reference?: string,
    public contractId?: number,
    public contractRef?: string,
    public productRef?: string,
    public type?: PackageV1UpdateType,
    public performedAt?: string,
    public userLogin?: string
  ) {}
}
